<template lang="pug">
.stepup.service-question-result-detail
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/service_question") {{ $t('Service Questions') }}
    li.active
      router-link(to="/service_question/results") {{ $t('Service Questions Result List') }}
    li.active
      span {{ $t('Service Questions Result Detail') }}
  div(v-if="shouldShow404")
    .row
      .col-xs-12
        .alert.alert-danger
          h1 404 - ページが見つかりません
          p アクセス権限がありません。
  div(v-else)
    div(v-if="$route.query.from==='user'")
      .row
        .col-xs-12.mb20
          a(v-on:click="goBack()").btn.btn-default 戻る
    div
    .row
      .col-xs-6
        p(v-if="user") {{ user.attributes['shop-name'] }} {{ user.attributes['user-type-name'] }} 
        h2(v-if="user") {{ user.attributes['user-name'] }} {{ user.attributes['user-firstname'] }}
      .col-xs-6.text-right
        a(v-if="answers.length" v-on:click="goDataDownload()").btn.btn-success 
          i.fa.fa-download
          span 評価シート出力
    .row
      .col-xs-12.mb20
        table(v-if="answers.length")
          tr
            th(rowspan=2) カテゴリー
            th(rowspan=2) シーン
            th(rowspan=2) 評価内容
            template(v-for="(answer_date, index) in answers[0]['answer_start_dates']")
              th.answer_date_current(colspan=2 v-if="index == answers[0]['answer_start_dates'].length - 1") {{answer_date}}
              th.answer_date(colspan=2 v-else) {{answer_date}}
          tr
            template(v-for="answer_date in answers[0]['answer_start_dates']")
              th.point 他己評価
              th.own_point 自己評価
          tr
            th(colspan=3) 総合評価
            template(v-for="(_, index) in answers[0]['answer_start_dates']")
              td.point {{ answers[0]['points'][index] > 0 ? answers[0]['points'][index] : '-' }}
              td.own_point {{ answers[0]['own_points'][index] > 0 ? answers[0]['own_points'][index] : '-'}}
          template(v-for="(answer, index) in answers")
            template(v-if="index > 0")
              tr
                th(v-if="!answers[index - 1]['category_id'] || answers[index - 1]['category_id'] !== answer['category_id']" :rowspan="answer['rowspan']") {{ answer['category_name'] }}
                th {{ answer['scene'] }}
                th {{ answer['content'] }}
                template(v-for="(point, answerIndex) in answer['points']")
                  template(v-if="(!answers[index - 1]['category_id'] || answers[index - 1]['category_id'] !== answer['category_id']) && answer['is_different'][answerIndex]")
                    td.point(:rowspan="answer['rowspan']") {{ point || '-' }}
                    td.own_point(:rowspan="answer['rowspan']") {{ answer['own_points'][answerIndex] || '-' }}
                  template(v-else-if="answer['is_different'][answerIndex]")
                  template(v-else)
                    td.point {{ point || '-' }}
                    td.own_point {{ answer['own_points'][answerIndex] || '-' }}
          tr
            th.text-right(colspan="3") 評価者
            template(v-for="(answerUsers, index) in answers[0]['answer_users']")
              td(colspan="2")
                p(v-for="answerUser in answerUsers") 
                  template(v-if="shouldShowEvaluatorLinksForColumn(index)")
                    a(href="#" @click.prevent="openHiddenModal(answerUser)") {{typeof answerUser === 'object' ? answerUser.name : answerUser}}
                  template(v-else)
                    span {{typeof answerUser === 'object' ? answerUser.name : answerUser}}
              
    .row
      .col-xs-12.mb20
        label 前回情報共有コメント
        textarea.form-control(rows=5, readonly='readonly', v-model="lastComment")
    .row
      .col-xs-12.mb20
        label 情報共有コメント
        textarea.form-control(rows=5, v-model="comment")
    .row.mb20(v-if="$route.query.from==='user'")
      .col-sm-4
      .col-sm-4.text-center
        a(v-on:click="saveComment()").btn.btn-success.btn-lg 保存
      .col-sm-4.text-right
        a(v-on:click="goBack()").btn.btn-default.btn-lg 戻る
    .row.mb20(v-else)
      .col-xs-12.text-center
        a(v-on:click="saveComment()").btn.btn-success.btn-lg 保存

  .modal(v-if="modalData['shift']" v-bind:class="{'-is-active': modalFlag}")
    .modal-container
      .modal-container-close(v-on:click="closeHiddenModal")
        .modal-container-close-wrap ×
      .modal-container-name
        .modal-container-name-name {{ modalData.shift ? modalData.shift.name + 'さんの評価' : '' }}
      .modal-container-select
        h4 保存する評価カテゴリを選択してください。
        .form-group
          label
            input(type="checkbox" v-model="hiddenFlags.showGreeting")
            span 挨拶
        .form-group
          label
            input(type="checkbox" v-model="hiddenFlags.showImpression") 
            span 印象
        .form-group
          label
            input(type="checkbox" v-model="hiddenFlags.showBehavior")
            span 所作
      .modal-container-button
        .modal-container-button-wrap
          button.btn.btn-default(@click="closeHiddenModal") キャンセル
          button.btn.btn-success(@click="saveHiddenFlags") 保存する
</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'service-question-result-detail',
  components: {
    AppHeader
  },
  data () {
    return {
      answers: [],
      lastComment: '',
      comment: '',
      modalFlag: false,
      modalData: {
        shift: null
      },
      hiddenFlags: {
        showGreeting: false,
        showImpression: false,
        showBehavior: false
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.userDetail
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return localStorage.is_shop_master === '1'
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    localShopId () {
      return window.localStorage.getItem('shop_id')
    },
    shouldShow404 () {
      if (!this.user) return false
      return !this.isSystemManagement && !this.isHumanStaff && this.isShopMaster && parseInt(this.user.attributes['shop-id']) !== parseInt(this.localShopId)
    }
  },
  created () {
    this.searchUser()
    this.search(false)
  },
  methods: {
    shouldShowEvaluatorLinksForColumn (columnIndex) {
      // 特定の列のヘッダー日付で評価者リンクを表示するかチェック
      if (!this.answers || !this.answers[0] || !this.answers[0]['answer_start_dates']) return false

      const answerStartDates = this.answers[0]['answer_start_dates']
      if (columnIndex >= answerStartDates.length) return false

      const today = new Date()
      const dateStr = answerStartDates[columnIndex]

      // "YYYY年MM月" 形式から日付を解析
      const match = dateStr.match(/(\d{4})年(\d{1,2})月/)
      if (!match) return false

      const headerYear = parseInt(match[1])
      const headerMonth = parseInt(match[2]) - 1 // JavaScriptの月は0ベース

      // dateStrの年月の20日から翌月10日までの間の場合のみリンクを有効
      const startDate = new Date(headerYear, headerMonth, 20)
      const endDate = new Date(headerYear, headerMonth + 1, 10)

      return today >= startDate && today <= endDate
    },
    searchUser () {
      this.$store.dispatch('USER_DETAIL', {
        id: this.$route.params.targetUserId,
        callback: function () {
          // User detail loaded successfully
        }
      })
    },
    goBack () {
      this.$router.push({ path: `/users/${this.$route.params.targetUserId}` })
    },
    async search () {
      let data = {
        service_question_id: this.$route.params.serviceQuestionId,
        target_user_id: this.$route.params.targetUserId,
        answer_start_date: this.$route.params.answerStartDate
      }
      let res = await this.$store.dispatch('GET_SERVICE_RESULT_DETAIL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.answers = res
      let resComment = await this.$store.dispatch('GET_SERVICE_RESULT_COMMENT', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.comment = resComment.comment
      this.lastComment = resComment.last_comment
    },
    saveComment () {
      let data = {
        service_question_id: this.$route.params.serviceQuestionId,
        target_user_id: this.$route.params.targetUserId,
        answer_start_date: this.$route.params.answerStartDate,
        comment: this.comment
      }
      this.$store.dispatch('UPDATE_SERVICE_RESULT_COMMENT', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async goDataDownload () {
      let data = {
        service_question_id: this.$route.params.serviceQuestionId,
        target_user_id: this.$route.params.targetUserId,
        answer_start_date: this.$route.params.answerStartDate
      }
      let res = await this.$store.dispatch('DOWNLOAD_SERVICE_RESULT_DETAIL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      window.setTimeout(async function () {
        await this.$store.dispatch('DELETE_SERVICE_RESULT_DETAIL', { data: data })
      }, 3000)
    },
    openHiddenModal (answerUser) {
      if (typeof answerUser === 'string') {
        console.error('answerUser is a string, expected object:', answerUser)
        return
      }

      if (!answerUser || !answerUser.hasOwnProperty('service_question_answer_id')) {
        console.error('answerUser missing required properties:', answerUser)
        return
      }

      this.modalData.shift = answerUser
      this.hiddenFlags.showGreeting = !answerUser.is_hidden1
      this.hiddenFlags.showImpression = !answerUser.is_hidden2
      this.hiddenFlags.showBehavior = !answerUser.is_hidden3
      this.modalFlag = true

      this.$nextTick(() => {
        const modal = document.querySelector('.modal')
        if (modal) {
          modal.style.display = 'block'
        }
      })
    },
    closeHiddenModal () {
      const modal = document.querySelector('.modal')
      if (modal) {
        modal.style.display = 'none'
      }

      for (var key in this.modalData) {
        this.modalData[key] = null
      }
      this.modalFlag = false
    },
    async saveHiddenFlags () {
      if (!this.modalData.shift) return

      const data = {
        is_hidden1: !this.hiddenFlags.showGreeting,
        is_hidden2: !this.hiddenFlags.showImpression,
        is_hidden3: !this.hiddenFlags.showBehavior
      }

      // アクションが存在するかチェック
      if (this.$store._actions['UPDATE_SERVICE_QUESTION_ANSWER_HIDDEN']) {
        try {
          const response = await this.$store.dispatch('UPDATE_SERVICE_QUESTION_ANSWER_HIDDEN', {
            id: this.modalData.shift.service_question_answer_id,
            data: data
          })

          if (response !== false) {
            await this.search()
            this.closeHiddenModal()
          } else {
            alert('保存に失敗しました。')
          }
        } catch (err) {
          console.error('Error updating hidden flags:', err)
          alert('保存に失敗しました。')
        }
      } else {
        // アクションが存在しない場合は、一時的に成功として処理
        console.warn('UPDATE_SERVICE_QUESTION_ANSWER_HIDDEN action not found')
        this.search()
        this.closeHiddenModal()
      }
    }
  }
}
</script>
<style>
.service-question-result-detail h2 {
  margin: 8px 0px 16px;
}
.service-question-result-detail table {
  width: 100%;
}
.service-question-result-detail th {
  border: 1px solid #ddd;
  padding: 8px;
}
.service-question-result-detail td {
  border: 1px solid #ddd;
  padding: 8px;
}
.service-question-result-detail .answer_date {
  text-align: center;
}
.service-question-result-detail .answer_date_current {
  color: #fff;
  background-color: #f0ad4e;
  text-align: center;
}
.service-question-result-detail td.point {
  color: #DB5A5A;
  font-size: 16px;
  font-weight: bold;
}
.service-question-result-detail .own_point {
  background-color: #eee;
}
.service-question-result-detail td.own_point {
  color: #C97C00;
  font-size: 14px;
}
.service-question-result-detail .mb20 {
  margin-bottom: 24px;
}
.modal {
  display: none;
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal.-is-active {
  display: block !important;
}
.modal-container {
  position: relative;
  background-color: #fff;
  margin: 10% auto;
  padding: 20px;
  width: 80%;
  max-width: 500px;
  border-radius: 5px;
}
.modal-container-close {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
}
.modal-container-name {
  margin-bottom: 20px;
  font-weight: bold;
}
.modal-container-select {
  margin-bottom: 20px;
}
.modal-container-button {
  text-align: center;
}
.modal-container-select .form-group {
  margin-bottom: 10px;
}
.modal-container-select .form-group label {
  display: flex;
  align-items: center;
}
.modal-container-select .form-group input[type="checkbox"] {
  margin-right: 8px;
}
.modal-container-button .btn + .btn {
  margin-left: 10px;
}
.modal-container-select h4 {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// ServiceQuestionResultDetail.vue?3361b8dc